<template>
	<div class="Aboutus">
		<div class="Aboutus-top">
			<div
				class="Aboutus-top-text"
				:class="{ 'Aboutus-top-text--en': lang === 'en' }"
			>
				<div class="Aboutus-top-texta">{{ $t('电子元件百强企业') }}</div>
				<div class="Aboutus-top-textb">{{ $t('先进技术陶瓷基地') }}</div>
			</div>
		</div>
		<div class="Aboutus-time">
			<div class="Aboutus-time-img">
				<img
					:src="require('@/assets/images/aboutustime.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Aboutus-time-text">
				<span class="time-text-left">{{ $t('关于') }}</span>
				<span class="time-text-rig">{{ $t('三环') }}</span>
			</div>
		</div>
		<h2 class="Aboutus-theme" v-if="lang === 'zh'">
			“材料+”构筑美好生活<br />"Materials Plus" Builds Better Life
		</h2>
		<h2 class="Aboutus-theme" v-else>"Materials Plus" Builds Better Life</h2>
		<div class="Aboutus-text">
			<template v-if="lang === 'zh'">
				<div class="Aboutus-text-line">
					潮州三环（集团）股份有限公司成立于1970年，2014年在深交所上市（股票简称：三环集团，股票代码：300408），在潮州、深圳、成都、德阳、南充、苏州、武汉、香港、德国、泰国等地均设有公司，是一家专注于先进材料研发、生产及销售的综合性高新技术企业。
				</div>
				<div class="Aboutus-text-line">
					半个世纪以来，公司秉承“‘材料+’构筑美好生活”的愿景，聚焦“材料”基因，以“材料+结构+功能”为发展方向，产品覆盖通信、电子、新能源、半导体、移动智能终端等众多应用领域。其中，光通信用陶瓷插芯、片式电阻用氧化铝陶瓷基板、半导体陶瓷封装基座等产品产销量均居全球前列，多项产品先后荣获国家优质产品金奖。公司被认定为国家高新技术企业、国家技术创新示范企业、国家企业技术中心、中国制造业单项冠军示范企业，连续多年入选中国电子元件百强企业。
				</div>
				<div class="Aboutus-text-line">
					三环集团始终践行“诚信勤勉、科技创新、成就人才、开放融合、行稳致远、追求卓越”的企业价值观，致力于为客户需求提供解决方案，为员工成长搭建发展平台，为股东投资创造增值回报，为社会发展贡献企业价值。
				</div>
				<div class="Aboutus-text-line">
					公司以人才和创新为发展核心，坚持“倾心引才、精心用才、悉心育才、真心爱才、匠心成才”的人才理念，大力引进和培养高素质人才，不断推动自主创新和转型升级。三环集团拥有以博士、硕士为主组成的技术研发团队，同时聘请多名两院院士及多位学科专家组成科学技术专家委员会，不断开展新材料、新产品、新技术的研究与创新，承担并完成多个国家、省级重点科研项目。公司坚持科学导向的创新理念与实事求是的思想原则，着眼于前沿技术开发，聚焦重点任务和关键环节，不断推进企业的高质量发展。
				</div>
				<div class="Aboutus-text-line">
					未来，三环集团将坚持永不停步的创新动力，开拓可持续发展的产品方向，完善能自我修正的管理机制，建立有凝聚力的企业文化，竭力打造集科技研发、高端制造、技术支持、人才聚集、市场服务等于一体的综合性产业基地，用技术创新引领高质量发展，用“材料+”构筑美好生活。
				</div>
			</template>
			<div class="Aboutus-text-line" style="margin-top: 20px">
				ChaoZhou Three-circle (Group) Co., Ltd. was founded in 1970 and listed
				on Shenzhen Stock Exchange in 2014 (stock code: 300408). The group has
				set up subsidiaries in Shenzhen, Chengdu, Nanchong, Deyang, Suzhou,
				Wuhan, Hong Kong, Germany, Thailand and other places. We are a
				comprehensive enterprise dedicated to researching, developing and
				selling basic electronic materials, electronic components, communication
				equipment, etc.
			</div>
			<div class="Aboutus-text-line">
				Over the past half century, we have been adhering to the vision of
				"'Materials Plus' Builds Better Life", focusing on the "material", and
				taking "material + structure + function" as our development direction.
				Our products cover fields such as electronics, new energy,
				communications, semiconductors, and mobile smart terminals. Among all of
				our products, the production and sales of ceramic ferrules for optical
				communication, alumina ceramic substrates for chip resistors, and
				semiconductor ceramic packaging bases are among the top in the world.
				And many products have won the National Quality Product Gold Award.
			</div>
			<div class="Aboutus-text-line">
				Moreover, the company has been recognized as a national high-tech
				enterprise, national technological innovation demonstration enterprise,
				national enterprise technology center, and a single champion
				demonstration enterprise in China's manufacturing industry. It has been
				rated as one of the top 100 Chinese electronic component enterprises for
				many years.
			</div>
			<div class="Aboutus-text-line">
				"Integrity and Diligence, Scientific and Technological Innovation,
				Foster Talents, Openness and Integration, Steady and Long-term
				Development, and Pursuit of Excellence", we always practice the
				corporate values and dedicates to provide solutions for customers, build
				a growth platform for employees, create investment opportunities for
				shareholders, and contribute values to social development. In addition,
				we see talents and innovation as the core of development, and introduce
				and nurture talents to furthur our mutual transformation and upgrade.
			</div>
			<div class="Aboutus-text-line">
				With a R&D team mainly composed of doctors and masters, and hired a
				number of academicians and subject experts to form a scientific and
				technical expert committee. We continue to carry out research and
				innovation of new materials, new products, and new technologies, and
				undertake and complete several national and provincial key scientific
				research projects. The company adheres to the scientific-oriented
				innovation concept and the ideological principle of seeking truth from
				facts, put eyes on the development of cutting-edge technologies, focuses
				on key tasks and key links, and continuously promotes the high-quality
				development of the enterprise.
			</div>
			<div class="Aboutus-text-line">
				In the future, CCTC will keep on innovating, extend a sustainable
				product directions, improve the management mechanism capablity of
				self-correction, establish a cohesive corporate culture, and strive to
				create a comprehensive industrial base consists of science and
				technology research, high-end manufacturing, technical support, talent
				gathering and market services. We will be leading high-quality
				development with technological innovation, and building a better world
				with advanced materials.
			</div>
		</div>
		<div class="Aboutus-num">
			<div class="Aboutus-num-item">
				<div class="num-item-top">
					<div class="item-top-left">
						<num-scroll end-val="15"> </num-scroll>
						<div class="top-left-right">+</div>
					</div>
				</div>
				<div class="num-item-bom">{{ $t('分支机构') }}</div>
			</div>
			<div class="Aboutus-num-item">
				<div class="num-item-top">
					<div class="item-top-left">
						<num-scroll end-val="50"> </num-scroll>
						<div class="top-left-right">+</div>
					</div>
				</div>
				<div class="num-item-bom">{{ $t('自主研发产品系列') }}</div>
			</div>
			<div class="Aboutus-num-item">
				<div class="num-item-top">
					<div class="item-top-left">
						<num-scroll end-val="2000"> </num-scroll>
						<div class="top-left-right">+</div>
					</div>
				</div>
				<div class="num-item-bom">{{ $t('研发人员') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import NumScroll from '../../components/Numscroll/Numscroll.vue';
export default {
	name: 'Aboutus',
	components: {
		NumScroll
	},
	data() {
		return {};
	}
};
</script>

<style lang="scss">
@use './Aboutus.scss';
</style>
